/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class CoursePopup extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(coursePopup, courseDeleteDetails) {
    coursePopup.setAttribute('name', this._detail.name);

    coursePopup.setAttribute('semantic-name', this._detail.semanticName);

    coursePopup.setAttribute('view', courseDeleteDetails.view);

    coursePopup.setAttribute('main-content', courseDeleteDetails.mainContent);

    coursePopup.setAttribute(
      'univ-semantic-name',
      this.pathQueryMap.pathMap.univ
    );

    if (
      this.pathQueryMap.pathMap.track &&
      this.pathQueryMap.pathMap.track !== 'undefined'
    )
      coursePopup.setAttribute(
        'track-semantic-name',
        this.pathQueryMap.pathMap.track
      );
  }
}
